module.exports = __webpack_public_path__ + "static/RemoteHealth-712d197f70c176017a8ec855aca41a0a.png";